
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformService } from '../../../services/platform.service';
import { PricingCardComponent } from './pricing-card/pricing-card.component';
import { ISubscriptionPlan } from 'src/app/framework/constants/subscription.constants';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { NotificationsService } from '@app/services/notifications.service';

@Component({
    selector: 'app-pricing-section',
    templateUrl: './pricing-section.component.html',
    styleUrls: ['./pricing-section.component.scss'],
    imports: [PricingCardComponent]
})
export class PricingSectionComponent implements OnInit {
  private platformService = inject(PlatformService)
  public router = inject(Router);
  private subscriptionService = inject(SubscriptionService);
  private notif = inject(NotificationsService);

  basicPlan: ISubscriptionPlan;
  premiumPlan: ISubscriptionPlan;
  arePlansLoading = false;

  ngOnInit() {
    this.loadPlans();
  }

  loadPlans() {
    this.arePlansLoading = true;
    this.subscriptionService.getAllPlans().subscribe({
      next: (plans) => {
        this.basicPlan = plans.find((plan) => plan.name.toLowerCase().includes('basic'));
        this.premiumPlan = plans.find((plan) => plan.name.toLowerCase().includes('premium'));
      },
      complete: () => {
        this.arePlansLoading = false;
      },
    });
  }

  openIntercom() {
    this.notif.showSuccess('Coming soon...');
  }

  protected basicPlanSelected() {
    if (this.platformService.isIOS() || this.platformService.isAndroid()) {
      //  in the future, when the client wants so, update this to open the app store.
      this.notif.showInfo('Reach us at contact@buildevo.com for a demo.');
      return;
    }

    this.router.navigate(['auth', 'register'], { queryParams: { selected_plan: 'basic' } });
  }

  protected premiumPlanSelectd() {
    if (this.platformService.isIOS() || this.platformService.isAndroid()) {
      //  in the future, when the client wants so, update this to open the app store.
      this.notif.showInfo('Reach us at contact@buildevo.com for a demo.');
      return;
    }

    this.router.navigate(['auth', 'register'], { queryParams: { selected_plan: 'premium' } });
  }
}
